import { TYPE } from './episodeContainer.types';

const initialState = {
  show: false,
  nameSerie: '',
  urlGetEpisode: null,
  episodes: [],
  loadingEpisodes: false,
};

export const episodeContainer = (state = initialState, action) => {
  const { payload, type } = action || {};

  switch (type) {
    case TYPE.SHOW_EPISODE_CONTAINER: {
      return {
        ...state,
        show: payload?.show,
        nameSerie: payload?.nameSerie,
        urlGetEpisode: payload?.urlGetEpisode,
      };
    }

    case TYPE.LOADING_EPISODES: {
      return {
        ...state,
        loadingEpisodes: payload?.active,
      };
    }

    case TYPE.GET_EPISODES: {
      return {
        ...state,
        episodes: payload?.episodes,
        loadingEpisodes: false,
      };
    }

    default:
      return state;
  }
};
